import React from 'react';
import { FormattedMessage } from 'react-intl';

const Traslate = (id, value = {}) => <FormattedMessage id={id} values={{ ...value }} />;

export default Traslate;
